import { atom } from 'recoil';

/**
 * Tracks which thread ID should display the typewriter animation.
 */
export const animatingThreadIdState = atom<string | null>({
    key: 'AnimatingThreadId',
    default: null
});
